export default function () {
    return {
        restrict: 'E',
        scope: {
            reloadCurrentPage: '=reloadCurrentPage',
            error: '@',
            enableReload: '@',
        },
        template: `<div class="progress">
                            <div class="progress-content">
                                <div class="row" id="progress-icon">
                                    <div class="col align-self-center">
                                        <img src="https://64.media.tumblr.com/avatar_1660af6dff50_128.pnj" alt="logo" width="70" height="70"
                                            style="margin-bottom: 12px;" />
                                    </div>
                                </div>

                                <div class="row" id="progress-text">
                                    <div class="col align-self-center">
                                        <label ng-bind-html="error"></label>
                                    </div>
                                </div>

                                <div class="row justify-content-center" id="progress-reload" ng-if="enableReload == 'true' || enableReload == ''">
                                    <div class="mdc-touch-target-wrapper">
                                        <button class="mdc-button" ng-click="reloadCurrentPage()" style="margin-top: 12px;">
                                            <span class="mdc-button__ripple"></span>
                                            <i class="material-icons mdc-button__icon" aria-hidden="true">refresh</i>
                                            <span class="mdc-button__label">Reload</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>`
    };
}